import React from 'react';
import { Translation } from 'react-i18next';
import { titleize } from 'underscore.string';
import formatMoney from 'utils/formatters/Money';

const shipmentFormatter = (cell, row) => {
  return (
    <a
      href={`/shipments/${row?.shipment?._id}`}
      target="_blank"
      rel="noreferrer noopener"
    >
      {cell}
    </a>
  );
};

const rateFormmater = (_cell, row) => {
  const shipper_rate = row.shipper_rate ? parseFloat(row.shipper_rate) : 0;
  return <div>{formatMoney(shipper_rate, row?.currency)}</div>;
};

const totalFormatter = (_cell, row) => {
  if (!row.shipper_unit_qty && !row.shipper_rate) {
    return <div> {formatMoney(0.0, row?.currency)}</div>;
  }
  const shipper_unit_qty = row.shipper_unit_qty
    ? parseFloat(row.shipper_unit_qty)
    : 1;
  const shipper_rate = row.shipper_rate ? parseFloat(row.shipper_rate) : 0;
  return (
    <div>{formatMoney(shipper_rate * shipper_unit_qty, row?.currency)}</div>
  );
};

const containerFormatter = (_cell, row) => {
  const equipments = row?.shipment?.equipments || [];
  const _equipments = equipments.map((loadDetails, i) => {
    return (
      <div key={i}>
        <div className="">
          <div key={loadDetails.equipment_id}>
            <span className="mb-1">{loadDetails}</span>
          </div>
        </div>
      </div>
    );
  });
  return _equipments;
};

const referenceNumberFormatter = (_cell, row) => {
  const referenceFields = {
    partnerShipmentId: 'PARTNER_SHIPMENT',
    work_order_number: 'WORK_ORDER_NUMBER',
    house_bill_number: 'HOUSE_BILL',
    mg_load_id: 'MG_LOAD_ID',
    mo_number: 'MO_NUMBER',
    tracking_id: 'TRACKING_ID',
    tracking: 'TRACKING',
    seal_number: 'SEAL_#',
    master_bol: 'MASTER_REFERENCE',
    delivery_order: 'DELIVERY_ORDER',
    scac_code: 'SCAC_CODE',
  };

  const reference_numbers = row?.shipment?.reference_numbers || [];
  /*
  const uniqueCell = _.uniq(reference_numbers || [], function (item) {
    return item.value;
  });
  */

  const referenceNumbers = reference_numbers
    .filter(
      (r) => !r.hidden && Object.keys(referenceFields).indexOf(r.name) > -1,
    )
    .map((refNum, i) => {
      const values = (refNum.value && refNum.value.match(/.{1,20}/g)) || [];
      return values.length ? (
        <div key={i}>
          <label className="font-bold text-grey-darker">
            <Translation>
              {(t, { i18n }) => (
                <>{titleize(t(referenceFields[refNum.name]))}</>
              )}
            </Translation>
          </label>
          <div className="">
            {values.map((value, idx) => (
              <div key={idx}>
                <span className="mb-1">{value}</span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div />
      );
    });
  return referenceNumbers;
};

const columns = [
  {
    dataField: 'shipment.shipment_id',
    text: 'Shipment',
    localizationSlug: 'SHIPMENT',
    count: 1,
    sort: true,
    formatter: shipmentFormatter,
    headerStyle: {
      width: '100px',
    },
  },
  {
    dataField: 'test',
    text: 'Reference Numbers',
    localizationSlug: 'REFERENCE_NUMBERS',
    titleize: true,
    sort: false,
    formatter: referenceNumberFormatter,
    headerStyle: {
      width: '125px',
    },
  },
  {
    dataField: 'shipment.equipments',
    text: 'Container',
    localizationSlug: 'CONTAINER',
    titleize: true,
    sort: false,
    formatter: containerFormatter,
    headerStyle: {
      width: '100px',
    },
  },
  {
    dataField: 'shipment.order_type',
    text: 'Type',
    localizationSlug: 'TYPE',
    titleize: true,
    sort: false,
    headerStyle: {
      width: '100px',
    },
  },
  {
    dataField: 'message',
    text: 'Accessorial',
    localizationSlug: 'ACCESSORIAL',
    count: 1,
    titleize: true,
    sort: false,
    headerStyle: {
      width: '100px',
    },
  },
  {
    dataField: 'shipper_rate',
    text: 'Rate',
    localizationSlug: 'RATE',
    count: 1,
    sort: false,
    headerStyle: {
      width: '50px',
    },
    formatter: rateFormmater,
  },
  {
    dataField: 'shipper_unit_qty',
    text: 'Units',
    localizationSlug: 'UNIT',
    count: 2,
    sort: false,
    headerStyle: {
      width: '50px',
    },
  },
  {
    dataField: 'total',
    text: 'Total',
    localizationSlug: 'TOTAL',
    sort: false,
    formatter: totalFormatter,
    headerStyle: {
      width: '50px',
    },
  },
  {
    dataField: 'shipper_note',
    text: 'Note',
    localizationSlug: 'NOTE',
    titleize: true,
    count: 1,
    sort: false,
    headerStyle: {
      width: '100px',
    },
  },
  {
    dataField: 'acceptChecked',
    text: 'Accept',
    localizationSlug: 'ACCEPT',
    sort: false,
    headerStyle: {
      width: '50px',
    },
  },
  {
    dataField: 'declineChecked',
    text: 'Decline',
    localizationSlug: 'DECLINE',
    sort: false,
    headerStyle: {
      width: '50px',
    },
  },
  {
    dataField: 'comment',
    text: 'Comment',
    localizationSlug: 'COMMENT',
    sort: false,
    headerStyle: {
      width: '200px',
    },
  },
];

export default {
  columns,
};
